import { render } from "./ShareDataView.vue?vue&type=template&id=0effb6b2&scoped=true"
import script from "./ShareDataView.vue?vue&type=script&lang=js"
export * from "./ShareDataView.vue?vue&type=script&lang=js"

import "./ShareDataView.vue?vue&type=style&index=0&id=0effb6b2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0effb6b2"]])

export default __exports__